import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38ed449c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=38ed449c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed449c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ed449c')) {
      api.createRecord('38ed449c', component.options)
    } else {
      api.reload('38ed449c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38ed449c&scoped=true", function () {
      api.rerender('38ed449c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RightToolbar/index.vue"
export default component.exports